// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

document.addEventListener('turbolinks:load', () => {
  document.querySelectorAll('[data-hero-video]').forEach((video) => {
    const showVideo = () => {
      video.classList.remove('opacity-0')
      video.classList.add('opacity-100')
    }

    if (video.readyState >= 2) {
      showVideo()
      return
    }

    video.addEventListener('loadeddata', showVideo, { once: true })
    video.addEventListener('canplay', showVideo, { once: true })
    video.addEventListener('error', showVideo, { once: true })
    setTimeout(showVideo, 2000)
  })

  const grid = document.querySelector('[data-project-grid]')
  const filtersWrap = document.querySelector('[data-project-filters]')
  const lightbox = document.querySelector('[data-project-lightbox]')

  if (grid && filtersWrap) {
    const cards = [...grid.querySelectorAll('[data-project-item]')]
    const buttons = [...filtersWrap.querySelectorAll('[data-filter-btn]')]

    const setActiveFilter = (value) => {
      buttons.forEach((btn) => {
        const isActive = btn.dataset.filterValue === value
        btn.dataset.active = isActive ? 'true' : 'false'
        btn.classList.toggle('bg-amber-400', isActive)
        btn.classList.toggle('text-slate-950', isActive)
        btn.classList.toggle('bg-slate-800', !isActive)
        btn.classList.toggle('text-slate-200', !isActive)
      })
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const value = btn.dataset.filterValue
        setActiveFilter(value)

        cards.forEach((card) => {
          const visible = value === 'all' || card.dataset.category === value
          card.classList.toggle('hidden', !visible)
        })
      })
    })
  }

  if (grid && lightbox) {
    const image = lightbox.querySelector('[data-project-lightbox-image]')
    const meta = lightbox.querySelector('[data-project-lightbox-meta]')
    const title = lightbox.querySelector('[data-project-lightbox-title]')
    const summary = lightbox.querySelector('[data-project-lightbox-summary]')
    const count = lightbox.querySelector('[data-project-lightbox-count]')
    const closeButtons = lightbox.querySelectorAll('[data-project-close]')
    const prevButton = lightbox.querySelector('[data-project-prev]')
    const nextButton = lightbox.querySelector('[data-project-next]')
    const state = { images: [], index: 0 }

    const crop = lightbox.querySelector('[data-project-lightbox-crop]')

    const fitLightboxCropToImage = () => {
      if (!crop || !image) return
      const w = image.naturalWidth
      const h = image.naturalHeight
      if (!w || !h) return
      // Drop Tailwind default so inline aspect-ratio always wins.
      crop.classList.remove('aspect-video')
      // Match the frame to the file so object-cover does not crop (same ratio).
      crop.style.aspectRatio = `${w} / ${h}`
      crop.style.maxHeight = 'min(52vh, 520px)'
    }

    const renderSlide = () => {
      if (!state.images.length) return
      count.textContent = `Image ${state.index + 1} of ${state.images.length}`

      const applyWhenSized = () => {
        if (image.naturalWidth && image.naturalHeight) {
          fitLightboxCropToImage()
          return true
        }
        return false
      }

      const afterLoad = () => {
        // Cached images sometimes report complete before naturalWidth is ready; retry briefly.
        if (applyWhenSized()) return
        let attempts = 0
        const tryAgain = () => {
          attempts += 1
          if (applyWhenSized() || attempts > 12) return
          requestAnimationFrame(tryAgain)
        }
        requestAnimationFrame(tryAgain)
      }

      const onError = () => {
        crop.classList.add('aspect-video')
      }
      image.addEventListener('load', afterLoad, { once: true })
      image.addEventListener('error', onError, { once: true })

      image.src = state.images[state.index]

      // Same URL as previous slide may not fire `load`; decode / rAF still picks up dimensions.
      const kick = () => {
        if (typeof image.decode === 'function') {
          image.decode().then(afterLoad).catch(afterLoad)
        } else {
          requestAnimationFrame(afterLoad)
        }
      }
      kick()
      if (image.complete) requestAnimationFrame(afterLoad)
    }

    const open = (card) => {
      state.images = (card.dataset.images || '').split('|').filter(Boolean)
      state.index = 0
      image.alt = card.dataset.title
      meta.textContent = `${card.dataset.projectCategory}`
      title.textContent = card.dataset.title
      summary.textContent = card.dataset.summary
      renderSlide()
      lightbox.classList.remove('hidden')
      document.body.classList.add('overflow-hidden')
    }

    const close = () => {
      lightbox.classList.add('hidden')
      document.body.classList.remove('overflow-hidden')
    }

    const prev = () => {
      if (!state.images.length) return
      state.index = (state.index - 1 + state.images.length) % state.images.length
      renderSlide()
    }

    const next = () => {
      if (!state.images.length) return
      state.index = (state.index + 1) % state.images.length
      renderSlide()
    }

    grid.querySelectorAll('[data-project-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => open(trigger.closest('[data-project-item]')))
    })

    closeButtons.forEach((btn) => btn.addEventListener('click', close))
    prevButton.addEventListener('click', prev)
    nextButton.addEventListener('click', next)
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) close()
    })

    document.addEventListener('keydown', (event) => {
      if (lightbox.classList.contains('hidden')) return
      if (event.key === 'Escape') close()
      if (event.key === 'ArrowLeft') prev()
      if (event.key === 'ArrowRight') next()
    })
  }
})
